module.exports = __webpack_public_path__ + "static/media/Oscar Mollohuanca Cruz.9e640651.jpg";